import { atom } from 'recoil';

export const regionsState = atom({
  key: 'regions',
  default: [],
});
